/// <reference path="../definitions/QueryTs.d.ts" />

class QueryUpload
    extends QueryElement<HTMLElement> {

    private _event: QueryEventAsync<QueryUploadFile>;
    public get dropEvent() { return this._event.expose() }

    constructor(element: HTMLElement, input: IQueryElement) {
        super(element);

        this._event = new QueryEventAsync<QueryUploadFile>();

        // Events for drop zone
        ["drag", "dragstart", "dragend", "dragover", "dragenter", "dragleave", "drop"]
            .forEach(a => this.on(a, (e) => {
                e.preventDefault();
                e.stopPropagation();  
            }));

        this.on("drop", async (e: DragEvent) => {
            let dataTransfer = e.dataTransfer;
            
            if (dataTransfer !== null) {
                for (let file of dataTransfer.files) {
                    this._event.trigger(new QueryUploadFileUpload(file));
                }

                // And do a cleanup
                dataTransfer.clearData();
            }
        });

        // Events for upload button
        this.on("click", () => input.trigger("click", true));

        input.on("change", (e: Event) => {
            let files = (<HTMLInputElement>e.srcElement).files;
            if(files === null)
                return;
            for(let file of files) {
                this._event.trigger(new QueryUploadFileUpload(file));
            }

            input.setVal("");
        })
    }
}
interface IQueryUploadFile {
    name: string;
    size: number;
    type: string;
}
interface IQueryUploadFileModel {
    id: any;
    preview?: string;
}
class QueryUploadFile {
    protected _file: IQueryUploadFile;
    protected _model?: IQueryUploadFileModel;

    constructor(file: IQueryUploadFile, model?: IQueryUploadFileModel) {
        this._file = file;
        this._model = model;
    }

    public get name() { return this._file.name; }
    public get size() { return this._file.size; }
    public get type() { return this._file.type; }
    public get model() { return this._model; }
}
class QueryUploadFileUpload
    extends QueryUploadFile {

    protected _file: File;

    constructor(file: File) {
        super(file);

        this._file = file;
    }

    async upload(extraData?: any) {
        let data = new FormData();
        data.append('File', this._file);

        for (let x in extraData) {
            data.append(x, extraData[x]);
        }

        let request = await new QueryRequest("/Api/FileUpload", {
            contentType: 'file',
            data: data
        }).request();

        this._model = await request.json();

        return this._model;
    }
}